import { render, staticRenderFns } from "./economic-evaluation.vue?vue&type=template&id=2beaa097&scoped=true"
import script from "./economic-evaluation.vue?vue&type=script&lang=js"
export * from "./economic-evaluation.vue?vue&type=script&lang=js"
import style0 from "./economic-evaluation.vue?vue&type=style&index=0&id=2beaa097&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beaa097",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2beaa097')) {
      api.createRecord('2beaa097', component.options)
    } else {
      api.reload('2beaa097', component.options)
    }
    module.hot.accept("./economic-evaluation.vue?vue&type=template&id=2beaa097&scoped=true", function () {
      api.rerender('2beaa097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/components/economic-evaluation.vue"
export default component.exports